<script>
export default {
  name: 'Amount',
  props: {
    exceptionData: {
      type: Object,
      required: true,
    },
    exceptionId: {
      type: Number,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      localException: {
        minimumAmount: undefined,
        valid: false,
        ...this.exceptionData,
      },
    };
  },
  methods: {
    validate() {
      let amount = String(this.localException.minimumAmount);
      if (!amount || amount.includes('.')) {
        this.localException.valid = false;
        return;
      }
      amount = amount.replace(',', '.');
      const parsedVal = Number(amount);
      if (Number.isNaN(parsedVal) || parsedVal < 0) {
        this.localException.valid = false;
        return;
      }
      this.localException.valid = true;
    },
  },
  watch: {
    localException: {
      deep: true,
      handler() {
        this.validate();
        this.$emit('update', { id: this.exceptionId, data: this.localException });
      },
    },
  },
  created() {
    this.validate();
  },
};
</script>

<template>
  <v-layout wrap>
    <v-flex xs12 mb-3>
      <span class="d-block">
        This exception skips due dates with remaining payment less than the amount chosen
      </span>
      <span class="d-block">
        The amount is in the currency of the domain
      </span>
    </v-flex>
    <v-flex xs6 pr-4>
      <v-text-field
        v-model="localException.minimumAmount"
        :disabled="disabled"
        label="Amount"
        clearable
      />
    </v-flex>
    <v-flex xs12>
      <span v-if="!localException.valid" class="error--text">
        The amount must be a valid amount, and above 0
      </span>
    </v-flex>
  </v-layout>
</template>



// WEBPACK FOOTER //
// src/components/Reminders/ExceptionTypes/Amount.vue